module.exports = __webpack_public_path__ + "assets-cabinet/img/help-chat-icon.af1dcb95.svg";